import { QueryKey, queryOptions } from '@tanstack/react-query'
import { z } from 'zod'

import { infoSkyApiUrl } from '@/config/consts'
import { normalizedNumberSchema } from '@/domain/common/validation'

export interface CollateralAtRiskDataPoint {
  drop: number
  value: number
}

const responseSchema = z.array(
  z.object({
    drop: z.string(),
    value: normalizedNumberSchema,
    symbol: z.string(),
  }),
)

export function collateralAtRiskQueryKey(): QueryKey {
  return ['collateral-at-risk']
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function collateralAtRiskQueryOptions() {
  return queryOptions({
    queryKey: collateralAtRiskQueryKey(),
    queryFn: fetchCollateralAtRisk,
  })
}

async function fetchCollateralAtRisk(): Promise<CollateralAtRiskDataPoint[]> {
  const res = await fetch(`${infoSkyApiUrl}/groups/staked/ilks/LSEV2-SKY-A/at-risk/`)
  if (!res.ok) {
    throw new Error('Failed to fetch collateral at risk data')
  }

  const raw = responseSchema.parse(await res.json())

  return raw
    .map((item) => ({
      drop: Number(item.drop),
      value: item.value.toNumber(),
    }))
    .sort((a, b) => b.drop - a.drop)
}
